import type { OrchestratorSchemas } from '@ctcells/contract'

import { orchestrator } from '../clients.ts'
import { keys } from '../keys.ts'
import { createQuery, type SkippableArgs } from '../query.ts'

export type AlarmRemoteSetting = OrchestratorSchemas['schemas']['AlarmRemoteSetting']

/** admin 설정. 스냅샷 + 쓰기 뒤 무효화, 폴링 없음. */
export const useAlarmRemoteSetting = createQuery<SkippableArgs | void, AlarmRemoteSetting>({
  key: () => keys.alarmRemote.all(),
  fetch: () =>
    orchestrator.request<AlarmRemoteSetting>({
      method: 'GET',
      path: '/settings/alarm-remote',
      retryOn401: true,
    }),
})
